import { FC } from 'react'

import { useParams } from 'react-router-dom'

import {
  ResourceDetailView,
  ResourceListView,
  useResourceListPaging,
} from 'core/resources'
import {
  useCompanyLoanConfigurationsDelete,
  useCompanyLoanConfigurationsGet,
  useCompanyLoanConfigurationsGetAll,
  useCompanyLoanConfigurationsUpdate,
} from 'core/types/generated/loan-types/hooks'
import { resourceCatalog } from 'core/types/generated/resources'
import {
  loanTypesResponseSchema,
  loanTypesUpdateRequestSchema,
} from 'core/utils/generated/formSchemas'

import { asRequestBody, listRows, record } from './helpers'

const resource = resourceCatalog.loanTypes

type ListQuery = Parameters<
  typeof useCompanyLoanConfigurationsGetAll
>[0]['query']

export const LoanTypesList: FC = () => {
  const { companyId } = useParams<{ companyId: string }>()
  const paging = useResourceListPaging<ListQuery>('cursor')
  const result = useCompanyLoanConfigurationsGetAll({
    companyId,
    query: paging.query,
  })

  return (
    <ResourceListView
      {...listRows(result)}
      paging={paging}
      resource={resource}
      schema={loanTypesResponseSchema}
    />
  )
}

export const LoanTypeDetail: FC = () => {
  const { companyId, loanTypeId } = useParams<{
    companyId: string
    loanTypeId: string
  }>()
  const result = useCompanyLoanConfigurationsGet({ companyId, loanTypeId })
  const update = useCompanyLoanConfigurationsUpdate({ companyId, loanTypeId })
  const remove = useCompanyLoanConfigurationsDelete({ companyId, loanTypeId })

  return (
    <ResourceDetailView
      {...record(result)}
      onDelete={async () => {
        await remove.mutateAsync()
      }}
      onSave={async (body) => {
        await update.mutateAsync(asRequestBody(body))
      }}
      resource={resource}
      schema={loanTypesResponseSchema}
      updateSchema={loanTypesUpdateRequestSchema}
    />
  )
}
